import { style } from "@vanilla-extract/css";
import { vars } from "../../styles";
import { breakpoints } from "../../styles/breakpoints";

export const elementSingleFixture = style({
  padding: "0.1rem 0",
  fontSize: vars.fontSizes.body.xs,

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      fontSize: vars.fontSizes.body.s,
    },
  },
});

export const elementMultiFixtures = style({
  padding: "0.1rem 0",
  fontSize: "0.65rem",
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      fontSize: vars.fontSizes.body.xs,
    },
  },
});
